"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardHeader = exports.Root = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const layouts_1 = require("../../layouts");
const PageHeader_1 = require("../../PageHeader");
const helpers_2 = require("../../PageHeader/helpers");
const PageHeader_2 = require("../../PageHeader/PageHeader");
const View_1 = require("../../View");
exports.Root = styled_components_1.default.div `
    padding-right: ${helpers_1.SPACING_M};
    height: ${helpers_1.SPACING_XXXL};
    box-sizing: border-box;
    border-bottom: ${helpers_1.BASE_BORDER_WIDTH} solid
        ${({ theme }) => theme.colors.borders[View_1.VIEW_BORDER.normal]};

    ${helpers_2.BackControl} {
        margin-left: 0;
        padding-left: ${helpers_1.SPACING_M};
        padding-right: ${helpers_1.SPACING_M};
        margin-right: -${helpers_1.SPACING_M};
        height: ${helpers_1.SIZE_XXL};
    }

    ${({ hasLeftPadding }) => hasLeftPadding &&
    (0, styled_components_1.css) `
            padding-left: ${helpers_1.SPACING_M};
        `}
`;
exports.PageWizardHeader = (0, helpers_1.createUIElement)('PageWizardHeader', (_a, ref) => {
    var { className, hasBack = false, disabledBack = false, title, description, rightAddon, rightAddonProps, onBackClick, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "hasBack", "disabledBack", "title", "description", "rightAddon", "rightAddonProps", "onBackClick", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(exports.Root, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'pagewizard-wizardheader', className: `vm-PageWizardHeader ${className}`, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, hasLeftPadding: !hasBack, ref: ref, style: style }),
        react_1.default.createElement(PageHeader_1.PageHeader, { hasBack: hasBack, disabledBack: disabledBack, onBackClick: onBackClick, title: title, secondaryText: description, content: rightAddon && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(layouts_1.Spacer, null),
                react_1.default.createElement(PageHeader_2.PageHeaderSeparator, null),
                react_1.default.cloneElement(rightAddon, rightAddonProps))) })));
});
//# sourceMappingURL=PageWizardHeader.js.map